var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLevelRoundLiveWorking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Icons",
    "data-name": "Level Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.884,
    height: 75.884,
    viewBox: "0 0 75.884 75.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.551,
    x2: 0.552,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf2a00"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M37.942,0A37.942,37.942,0,1,1,0,37.942,37.942,37.942,0,0,1,37.942,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356",
    transform: "translate(-3.492 -1.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(19.127 22.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    d: "M1.716,1.727V27.635H42.9V1.727H1.716M1.716,0H42.9a1.722,1.722,0,0,1,1.716,1.727V27.635A1.722,1.722,0,0,1,42.9,29.363H1.716A1.722,1.722,0,0,1,0,27.635V1.727A1.722,1.722,0,0,1,1.716,0Z",
    transform: "translate(0 4.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(7.267 11.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 6.457,
    height: 1.291,
    transform: "translate(0 2.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(23.246 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 1.291,
    height: 6.457,
    transform: "translate(2.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 6.457,
    height: 1.291,
    transform: "translate(0 2.583)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    d: "M1.652,1.652v3.3h8.26v-3.3H1.652M1.652,0h8.26a1.652,1.652,0,0,1,1.652,1.652v3.3A1.652,1.652,0,0,1,9.912,6.608H1.652A1.652,1.652,0,0,1,0,4.956v-3.3A1.652,1.652,0,0,1,1.652,0Z",
    transform: "translate(3.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    d: "M1.652,1.652v3.3h8.26v-3.3H1.652M1.652,0h8.26a1.652,1.652,0,0,1,1.652,1.652v3.3A1.652,1.652,0,0,1,9.912,6.608H1.652A1.652,1.652,0,0,1,0,4.956v-3.3A1.652,1.652,0,0,1,1.652,0Z",
    transform: "translate(28.094)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelRoundLiveWorking);
export default __webpack_public_path__ + "static/media/icon_level_round_Live_Working.4c9915036cfa2167d91c082c40bd7f65.svg";
export { ForwardRef as ReactComponent };